import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "3c7a1a40-617a-4084-b637-5ee63d738bec",
  publicId: "15",
  name: "Room acoustic design elements at the disposal of architectural design",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
